import HubBuyTherapyGrantPage from './HubBuyTherapyGrantPage'

export default HubBuyTherapyGrantPage
